import { render, staticRenderFns } from "./collection.vue?vue&type=template&id=3080fa96&scoped=true&"
import script from "./collection.vue?vue&type=script&lang=js&"
export * from "./collection.vue?vue&type=script&lang=js&"
import style0 from "./collection.vue?vue&type=style&index=0&id=3080fa96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3080fa96",
  null
  
)

export default component.exports